/* unplugin-vue-components disabled */import { render } from "./pro_card.vue?vue&type=template&id=ef524d72&scoped=true"
import script from "./pro_card.vue?vue&type=script&lang=js"
export * from "./pro_card.vue?vue&type=script&lang=js"

import "./pro_card.vue?vue&type=style&index=0&id=ef524d72&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef524d72"]])

export default __exports__